import React from 'react';
import {ReactComponent as Icon} from 'images/icon/person.svg';
import classNames from 'classnames';

export default class PersonIcon extends React.PureComponent {
  render() {
    return (
      <Icon
        className={classNames('icon person', this.props.className)}
        onClick={this.props.onClick}
      />
    );
  }
}
